import uuid from 'uuid'

export const createEmptyState = _ => {
    return {
        id: uuid(),
        label: '',
        color: null,
        group: 'active',
    }
}

export const createEmptyConnection = _ => {
    return {
        id: uuid(),
        label: '',
        from: '',
        to: '',
        guards: [],
        event: 'manually',
    }
}
